/**
 * #2226 予約の返金をカードに返せないか (返金の記録 規則 6、services/pay/api/routers/reservations.py)。
 *
 * カードの解約・期限切れ・紛失・盗難で失敗した返金は、同じカードには何度やり直しても返せない。
 * お金はお店に戻るので、お店が別の方法で返す。サーバの `refund_card_unreachable` と同じ判定。
 */
import type { Reservation } from '../store/useStore'

const CARD_UNREACHABLE_MARKERS = ['expired_or_canceled_card', 'lost_or_stolen_card']

export function refundCardUnreachable(r: Pick<Reservation, 'refundStatus' | 'refundError'>): boolean {
  if (r.refundStatus !== 'failed') return false
  const error = r.refundError || ''
  return CARD_UNREACHABLE_MARKERS.some((m) => error.includes(m))
}

/** 未返金 (約束 − 実績)。お店の画面に出す額 */
export function outstandingRefund(r: Pick<Reservation, 'refundIntendedAmount' | 'refundedAmount'>): number {
  return Math.max(0, (r.refundIntendedAmount ?? 0) - (r.refundedAmount ?? 0))
}
